import { useTranslation } from 'react-i18next'

import Text from '../../../Text'

function EmailProfileMessageAttachedFilesModalCounter({ count }) {
  const { t } = useTranslation()

  return (
    <Text isSecondary>
      {t('EmailProfile.AttachedFilesModalCounterTextKey', { count })}
    </Text>
  )
}

export default EmailProfileMessageAttachedFilesModalCounter
